/**
 * A score as a whole percent, like the grades (owner ruling 2026-10-29: "a
 * tenth of a point means nothing for an audit score") — "96%". Never 100%
 * unless it is perfect: 99.6 reads "99%", so a failed item can't look clean.
 * Shared with the server's audit PDF (no browser imports here).
 */
export function wholeScore(n: number): number {
  const whole = Math.round(n);
  return whole >= 100 && n < 100 ? 99 : whole;
}

export function scorePct(n: number): string {
  return `${wholeScore(n)}%`;
}
